// * GET =====================================
export const UTILS_DATA_OBJECT_GET_OBJECT = `/utils_data_object/object`;

export const UTILS_DATA_OBJECT_GET_LIST_CONNECTORS = `/utils_data_object/list_connectors`;

export const UTILS_DATA_OBJECT_GET_LIST_COMPANIES = `/utils_data_object/list_companies`;

export const UTILS_DATA_OBJECT_GET_LIST_OUTPUT_SETTINGS = `/utils_data_object/list_output_settings`;

export const UTILS_DATA_OBJECT_GET_LIST_OUTPUT_TEMPLATES = `/utils_data_object/list_output_templates`;
// * PATCH ===================================

// * POST ====================================
export const UTILS_DATA_OBJECT_POST_LIST_PRINCIPALS = `/utils_data_object/list_principals`;

export const UTILS_DATA_OBJECT_POST_LIST_PRINCIPALS_BY_IDS = `/utils_data_object/list_principals_by_ids`;

export const UTILS_DATA_OBJECT_POST_MOVE_OBJECTS = `/utils_data_object/move_objects`;

export const UTILS_DATA_OBJECT_POST_SET_DIMENSIONS = `/utils_data_object/set_dimensions`;

export const UTILS_DATA_OBJECT_POST_DETACH_DIMENSION = `/utils_data_object/detach_dimension`;

export const UTILS_DATA_OBJECT_POST_SCHEDULE = `/utils_data_object/schedule`;

export const UTILS_DATA_OBJECT_POST_SHARE = `/utils_data_object/share`;

export const UTILS_DATA_OBJECT_POST_TOGGLE_DIMENSION_JOIN_TYPE = `/utils_data_object/toggle_dimension_join_type`;

export const UTILS_DATA_OBJECT_POST_TOGGLE_PERIOD_LOCKED = `/utils_data_object/toggle_period_locked`;

export const UTILS_DATA_OBJECT_POST_USED_BY = `/utils_data_object/used_by`;
// * DELETE ==================================

// * PUT =====================================
